import { createPinia } from 'pinia'

// Import all store modules
import { useDashboardStore } from './modules/dashboard'
import { useBenchmarkStore } from './modules/benchmark'
import { useComparativeStore } from './modules/comparative'
import { useRollupStore } from './modules/rollup'

// Create and export the pinia instance
export const pinia = createPinia()

// Export all store modules for easy access
export {
  useDashboardStore,
  useBenchmarkStore,
  useComparativeStore,
  useRollupStore,
}

// Export store types for advanced usage
export type { RollupStore } from './modules/rollup'

// Export shared types
export type * from '../types/stores'
